"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.moveRecipeSectionsMutationOptions = exports.moveRecipeSectionsMutation = void 0;
const client_1 = require("@apollo/client");
const recipesByCookbookAndSectionId_1 = require("../queries/recipesByCookbookAndSectionId");
exports.moveRecipeSectionsMutation = client_1.gql `
  mutation MoveRecipeSections($options: MoveRecipeOptions!) {
    moveRecipeSections(options: $options) {
      ok
    }
  }
`;
exports.moveRecipeSectionsMutationOptions = (variables, sectionIdToRemove, recipeInfo) => ({
    variables,
    update: cache => {
        if (sectionIdToRemove) {
            try {
                const data = cache.readQuery({
                    query: recipesByCookbookAndSectionId_1.recipesByCookbookAndSectionIdQuery,
                    variables: { sectionId: sectionIdToRemove },
                });
                if (data) {
                    cache.writeQuery({
                        query: recipesByCookbookAndSectionId_1.recipesByCookbookAndSectionIdQuery,
                        variables: {
                            sectionId: sectionIdToRemove,
                        },
                        data: {
                            __typename: "Query",
                            recipesByCookbookAndSectionId: data.recipesByCookbookAndSectionId.filter(x => x.id !== variables.options.recipeId),
                        },
                    });
                }
            }
            catch (_a) { }
        }
        if (recipeInfo) {
            try {
                const data = cache.readQuery({
                    query: recipesByCookbookAndSectionId_1.recipesByCookbookAndSectionIdQuery,
                    variables: { sectionId: variables.options.targetSectionId },
                });
                if (data) {
                    cache.writeQuery({
                        query: recipesByCookbookAndSectionId_1.recipesByCookbookAndSectionIdQuery,
                        variables: {
                            sectionId: variables.options.targetSectionId,
                        },
                        data: {
                            __typename: "Query",
                            recipesByCookbookAndSectionId: [
                                ...data.recipesByCookbookAndSectionId,
                                recipeInfo,
                            ],
                        },
                    });
                }
            }
            catch (_b) { }
        }
    },
});
//# sourceMappingURL=moveRecipeSections.js.map